/* eslint-disable @typescript-eslint/no-explicit-any */
import { cn } from "@/lib/utils";
import { PermissionCheck } from "./permission-check";
import { getPermissionLabel } from "../react-hook/default-permission";

type ValueProp = {
  name: string;
  view: boolean | string;
  create: boolean | string;
  update: boolean | string;
  delete: boolean | string;
  view_own_data_only: boolean | string;
};
type PermissionInputControlProp = {
  value: ValueProp;
  onChange: (prop: any) => void;
  list: ValueProp[];
  isRoleDisabled: boolean;
  show: boolean;
};
export const PermissionInputControl = ({
  value,
  onChange,
  list,
  isRoleDisabled,
  show,
}: PermissionInputControlProp) => {
  const handleChange = (key: string, propValue: boolean) => {
    console.log({ key, value, list });
    const isExist = list.find((item) => item.name === value.name);
    let temp_value = [];
    if (isExist) {
      temp_value = list.map((item) => {
        if (item.name === value.name) {
          return {
            ...item,
            [key]: propValue,
          };
        }
        return item;
      });
    } else {
      temp_value = [
        ...list,
        {
          ...value,
          [key]: propValue,
        },
      ];
    }
    onChange(temp_value);
  };
  const isCurrentDisabled = value.name === "roles" && isRoleDisabled;
  return (
    <div className={cn("flex w-full border-b", show ? "" : "hidden")}>
      <div
        className={cn("flex-1 py-2 px-3", { "opacity-65": isCurrentDisabled })}
      >
        {getPermissionLabel(value.name)}
      </div>
      <div className="w-[100px]  py-2 px-3">
        {value.view === "N/A" ? (
          <span className="text-sm text-slate-600">N/A</span>
        ) : (
          <PermissionCheck
            checked={value.view ? true : false}
            onClick={(prop) => handleChange("view", prop)}
            disabled={isCurrentDisabled}
          />
        )}
      </div>
      <div className="w-[100px]  py-2 px-3">
        {value.create === "N/A" ? (
          <span className="text-sm text-slate-600">N/A</span>
        ) : (
          <PermissionCheck
            checked={value.create ? true : false}
            onClick={(prop) => handleChange("create", prop)}
            disabled={isCurrentDisabled}
          />
        )}
      </div>
      <div className="w-[100px]  py-2 px-3">
        {value.update === "N/A" ? (
          <span className="text-sm text-slate-600">N/A</span>
        ) : (
          <PermissionCheck
            checked={value.update ? true : false}
            onClick={(prop) => handleChange("update", prop)}
            disabled={isCurrentDisabled}
          />
        )}
      </div>
      <div className="w-[100px]  py-2 px-3">
        {value.delete === "N/A" ? (
          <span className="text-sm text-slate-600">N/A</span>
        ) : (
          <PermissionCheck
            checked={value.delete ? true : false}
            onClick={(prop) => handleChange("delete", prop)}
            disabled={isCurrentDisabled}
          />
        )}
      </div>
      <div className="w-[150px]  py-2 px-3">
        {value.name !== "document" ? (
          <span className="text-sm text-slate-600">N/A</span>
        ) : (
          <PermissionCheck
            checked={value.view_own_data_only ? true : false}
            onClick={(prop) => handleChange("view_own_data_only", prop)}
            disabled={isCurrentDisabled}
          />
        )}
      </div>
    </div>
  );
};
